// @core/api/endpoints/fiscalization/get_fiscal_receipt.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetFiscalReceiptResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Get fiscal receipt by ID
 * Retrieves a fiscal receipt with all items, payments, fiscal attributes, and current processing status.
 */
export async function GetFiscalReceipt(
  id: string,
  options?: RequestOptions
): Promise<GetFiscalReceiptResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-receipts/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetFiscalReceiptResponse>(requestPath, { ...requestOptions });
}
